export const Experiences = {
  ON: 'on',
  OFF: 'off',
  CA_OFF: 'california_off',
  CONTROL: 'control',
  EXCLUDED: 'excluded',
};

export const FullTermQuoteSavingsCalloutExperiences = {
  HIDE: 'hide_full_term_quote_savings_experience',
  SHOW: 'show_full_term_quote_savings_experience',
};

export const SecurePasswordExperiences = {
  CONTROL: Experiences.CONTROL,
  EXCLUDED: Experiences.EXCLUDED,
  SECURE_PASSWORD_EXPERIENCE: 'secure_password_experience',
};

export const BypassQuoteLandingExperiences = {
  CONTROL: Experiences.CONTROL,
  EXCLUDED: Experiences.EXCLUDED,
  TABBED: 'tabbed',
  LINKED: 'linked',
};

export const AdvertiseTestDriveExperiences = {
  CONTROL: Experiences.CONTROL,
  COMBINATION: 'combination',
  SAVINGS: 'savings',
};

export const IsRootRightForYouExperiences = {
  CONTROL: Experiences.CONTROL,
  IS_ROOT_RIGHT_FOR_YOU: 'is_root_right_for_you',
};

export const DayZeroPacerScreenRehaul = {
  CONTROL: Experiences.CONTROL,
  SHOW_DAY_ZERO_PACER_REHAUL: 'show_day_zero_pacer_rehaul',
};

export const DayZeroWebOptimizeProfileToQuoteExperiences = {
  CONTROL: Experiences.CONTROL,
  SKIP_ADVERTISE_TEST_DRIVE: 'skip_advertise_test_drive',
};

export const TopOfFunnelIntake = {
  CONTROL: Experiences.CONTROL,
  TIMING: 'timing',
  INFO: 'info',
};

export const IsRootRightForYouZipCodeExperiences = {
  INVALID_ZIP_CODE: 'invalid_zip_code',
  NON_TEST_DRIVE_MARKET: 'non_test_drive_market',
  MARKET_NOT_SUPPORTED: 'market_not_supported',
  FULL: 'full',
};
export class DocumentRequestsSelfServiceBuckets {
  static CONTROL = Experiences.CONTROL;
  static COPY = 'copy';
  static COPY_AND_DOWNLOAD = 'copy_and_download';
}

export const TelematicsApplicationSchedules = {
  AT_RENEWAL: 'at_renewal',
  AFTER_TELEMATICS_PERIOD: 'after_telematics_period',
};
